module.exports = __webpack_public_path__ + "static/img/beta_bg_white_07.e120a536.svg";